import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	justify-content: center;
	margin-bottom: -8px;
`;

export const Toggle = styled.div`
	position: relative;
	background: ${(p) => p.theme.gray[0]};
	border-radius: 24px;
	display: inline-grid;
	grid-template-columns: 1fr 1fr;

	@media (max-width: 768px) {
		width: 100%;
	}
`;

export const Option = styled.button<{ $active: boolean }>`
	position: relative;
	z-index: 2;
	text-align: center;
	padding: 10px 32px;
	font-size: 14px;
	font-weight: 500;
	transition: color 0.3s ease;
	border-radius: 20px;
	border: none;
	background: transparent;
	color: ${(p) => (p.$active ? p.theme.gray[1000] : p.theme.gray[600])};

	&:focus {
		outline: none;
	}
`;

export const Indicator = styled.div<{ $isYearly: boolean }>`
	position: absolute;
	top: 4px;
	left: 4px;
	width: calc(50% - 4px);
	height: calc(100% - 8px);
	background: ${(p) => p.theme.gray[200]};
	border-radius: 20px;
	transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	z-index: 1;
	transform: ${(p) => (p.$isYearly ? 'translateX(100%)' : 'translateX(0)')};
`;
